import { Component, Input, ViewChild, inject } from '@angular/core';
import { IonContent } from '@ionic/angular';

import { BaseListPage } from 'src/app/@shared/base-list-page';
import { RoleModel, RoleSource } from 'src/app/role/@shared/role.model';
import { UserService } from 'src/app/user/@shared/user.service';
import { takeUntil } from 'rxjs/operators';

const SKELETON_ITEM_COUNT = 5;

@Component({
  selector: 'page-role-list-modal',
  standalone: false,
  styleUrls: ['./role-list-modal.component.scss'],
  templateUrl: './role-list-modal.component.html',
})
export class RoleListModalComponent extends BaseListPage<RoleModel, RoleSource> {
  @Input() public isMultiSelect: boolean;
  @Input() public selectedItems: RoleModel[] = [];

  @ViewChild('ListContent', {
    static: false,
  }) public content: IonContent;

  public readonly pageTrackName = 'RoleListModalComponent';

  public roles: RoleModel[] = [];
  public currentListType: 'thumbnail' | 'card' = 'thumbnail';
  public isLoading: boolean = false;

  public selectedItemIds: string[] = [];
  public totalItemsInDatabase: number;

  private userService = inject(UserService);

  public onItemClicked(item: RoleModel): Promise<boolean> {
    this.toggleSelectedItem(item);

    return Promise.resolve(true);
  }

  public dismiss(data?: RoleModel[]): void {
    this.modalController.dismiss(data).catch();
  }

  public submit(): void {
    const sorted = this.selectedItems
      .slice()
      .sort((a, b) => {
        if (a.displayName < b.displayName) {
          return -1;
        } else if (a.displayName === b.displayName) {
          return 0;
        }

        return 1;
      });

    this.dismiss(sorted);
  }

  public toggleSelectedItem(item: RoleModel): void {
    if (!this.isMultiSelect) {
      this.selectedItems = [item];
      this.selectedItemIds = [item.id];

      return;
    }

    if (this.selectedItems.find((o) => { return o.id === item.id; })) {
      this.selectedItems = this.selectedItems.filter((o) => { return o.id !== item.id; });
    } else {
      this.selectedItems.push(item);
    }

    this.selectedItemIds = this.selectedItems.map((o) => { return o.id; });
  }

  protected protoOnInit(): void {
    this.selectedItemIds = this.selectedItems.map((o) => {
      return o.id;
    });

    this.initList();
  }

  protected subscribeToContent(): void {
    this.subscribeToCurrentList();
  }

  protected initList(): void {
    this.isLoading = true;
    this.roles = Array(SKELETON_ITEM_COUNT).fill(null);
  }

  private subscribeToCurrentList(): void {
    this.userService.getRoles()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((roles: RoleModel[]): void => {
        this.roles = roles;
        this.totalItemsInDatabase = this.roles.length;
        this.isLoading = false;
      });
  }
}
